var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkinpreferenceandconcern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_376_32703)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#D8EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6847 54.742C37.6083 54.758 37.5309 54.7714 37.4524 54.7818C35.747 55.0095 34.18 53.8115 33.9524 52.1062L33.4613 48.4277C33.2337 46.7224 34.4317 45.1554 36.137 44.9277M62.6743 54.8096C64.2075 54.8048 65.5398 53.6684 65.7484 52.1062L66.2395 48.4277C66.4355 46.9592 65.5744 45.5932 64.2424 45.0969M51.1351 54.6428V49.2231C51.1351 47.7818 52.0529 46.5005 53.4176 46.0366L53.8306 45.89C54.6703 45.6046 55.5601 45.4967 56.4437 45.5731C57.3273 45.6496 58.1854 45.9088 58.9636 46.3342L59.9428 46.8695M47.9016 46.3513L46.5446 45.8901C45.7049 45.6046 44.815 45.4967 43.9314 45.5732C43.0478 45.6497 42.1898 45.9088 41.4116 46.3343L40.4323 46.8696",
    stroke: "#004276",
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.165 49.2734C44.759 49.2734 45.241 49.7548 45.2412 50.3486C45.2412 50.9427 44.7591 51.4248 44.165 51.4248C43.5712 51.4246 43.0898 50.9425 43.0898 50.3486C43.0901 49.7549 43.5713 49.2737 44.165 49.2734Z",
    fill: "url(#paint0_linear_376_32703)",
    stroke: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1768 49.2734C56.7707 49.2734 57.2527 49.7548 57.2529 50.3486C57.2529 50.9427 56.7708 51.4248 56.1768 51.4248C55.5829 51.4246 55.1016 50.9425 55.1016 50.3486C55.1018 49.7549 55.5831 49.2737 56.1768 49.2734Z",
    fill: "url(#paint1_linear_376_32703)",
    stroke: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7358 50.0963L58.2266 49.6136M43.6331 50.0963L42.1424 49.6136M64.8702 40.7399C64.8596 41.4114 64.8033 42.0813 64.7015 42.7451L63.1849 50.5356C63.1849 55.7937 60.9102 59.5396 56.9097 62.952C54.6856 64.8491 52.2303 65.993 50.1889 65.993C48.1474 65.993 45.6921 64.8491 43.468 62.952C39.4676 59.5396 37.1928 55.7937 37.1928 50.5356L35.861 41.9767C35.0152 33.4232 41.7343 26.0068 50.3295 26.0068C55.1687 26.0068 59.3898 28.3494 62.0198 31.9011",
    stroke: "#004276",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8127 34.376C55.8127 34.376 41.5134 36.2756 36.8477 47.1037M54.6055 37.5001C54.6055 37.5001 60.5598 38.8284 63.7248 47.1037M46.7638 57.9048C47.7916 58.9776 49.345 57.7332 50.2714 58.6391C51.3145 57.7903 52.535 58.9203 53.7789 57.9048",
    stroke: "#004276",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2596 61.61V61.7042M66.2596 65.2381V65.3322M64.3985 63.4712H64.4926M68.0266 63.4712H68.1207M64.7282 33.8346V33.9287M64.7282 37.4626V37.5567M62.867 35.6957H62.9611M66.4951 35.6957H66.5892M33.3454 25.8154V25.9096M33.3454 29.4435V29.5376M31.4844 27.6766H31.5785M35.1125 27.6766H35.2066M33.9844 58.4002V58.4943M33.9844 62.0283V62.1224M32.1233 60.2613H32.2174M35.7514 60.2613H35.8455M49.3816 61.2675H51.158",
    stroke: "#004276",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_376_32703",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_376_32703"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_376_32703",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_376_32703",
    x1: 42.5898,
    y1: 50.3491,
    x2: 45.7412,
    y2: 50.3491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B0491",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09048C",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_376_32703",
    x1: 54.6016,
    y1: 50.3491,
    x2: 57.7529,
    y2: 50.3491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B0491",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09048C",
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinpreferenceandconcern);
export default __webpack_public_path__ + "static/media/skin preference and concern.d9781184f04baea509f41b8958ae44bf.svg";
export { ForwardRef as ReactComponent };